<template>
  <div class="teen-page teen12">
    <div class="header">
      <h1>丝绸之路：文明的纽带</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_12.png" alt="丝绸之路">
        <div class="caption">丝绸之路，连接东西方的贸易通道</div>
      </div>

      <h2>一、 历史背景</h2>
      <p>丝绸之路是古代连接中国与西方的重要贸易通道。它始于西汉时期，张骞出使西域后逐渐形成。丝绸之路不仅是商品交换的通道，也是文化交流的桥梁。</p>

      <h2>二、 路线走向</h2>
      <p>丝绸之路以长安（今西安）为起点，经过河西走廊、西域，到达中亚、西亚，最终到达欧洲。它分为陆上丝绸之路和海上丝绸之路两条主要路线。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_12.png" alt="丝绸之路地图">
        <div class="caption">丝绸之路路线图，横跨亚欧大陆</div>
      </div>

      <h2>三、 商品交换</h2>
      <p>丝绸之路上交易的商品种类繁多，中国的丝绸、瓷器、茶叶等运往西方，而西方的香料、珠宝、玻璃等传入中国。其中，丝绸是最具代表性的商品，丝绸之路也因此得名。</p>

      <h2>四、 文化交流</h2>
      <p>丝绸之路促进了东西方文化的交流与融合。佛教、伊斯兰教等宗教通过丝绸之路传入中国，而中国的四大发明也通过丝绸之路传播到西方。</p>

      <div class="quote-box">
        "使者相望于道，商旅不绝于途。" —— 《汉书》
      </div>

      <h2>五、 现代意义</h2>
      <p>今天，"一带一路"倡议继承了丝绸之路的精神，旨在促进沿线国家的合作与发展，共同构建人类命运共同体。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen12'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #fdf5e6;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #d4a574 0%, #c4956a 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #8b6914;
  border-bottom: 2px solid #d4a574;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #fdf5e6;
  padding: 20px;
  border-left: 4px solid #d4a574;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>